/* eslint-disable no-console */
import MyCommitmentsLayout from "../layouts/MyCommitmentsLayout";

export default ( {
	app,
	authService,
	loadedSlices,
} ) => {
	const lazyLoadSliceComponent = ( { component, } ) => {
		return () => {
			if ( !loadedSlices.has( "@teaming/slice-actionItems" ) ) {
				return import( "@teaming/slice-actionItems" ).then( async ( { actionItemsSlice, } ) => {
					actionItemsSlice();
					loadedSlices.set( "@teaming/slice-actionItems", true );
					return app.component( component );
				} );
			}
			return Promise.resolve( app.component( component ) );
		};
	};

	const routes = [
		{
			path: "/action-items",
			name: "my-action-items",
			meta: { title: "slice-actionItems.routes.myActionItems", },
			component: MyCommitmentsLayout,
			props: true,
			children: [
				{
					path: "",
					name: "Action Item Listing",
					component: lazyLoadSliceComponent( { component: "MyCommitmentsHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},
	];

	return routes;
};
